var map = {
	"./": [
		"wOor",
		9
	],
	"./Type1": [
		"k64q",
		9,
		32
	],
	"./Type1/": [
		"k64q",
		9,
		32
	],
	"./Type1/index": [
		"k64q",
		9,
		32
	],
	"./Type1/index.js": [
		"k64q",
		9,
		32
	],
	"./Type1/upsells": [
		"uHP2",
		9,
		77
	],
	"./Type1/upsells.jsx": [
		"uHP2",
		9,
		77
	],
	"./Type1/upsells.module.scss": [
		"/l7Q",
		7,
		158
	],
	"./Type2": [
		"3IRy",
		9,
		33
	],
	"./Type2/": [
		"3IRy",
		9,
		33
	],
	"./Type2/index": [
		"3IRy",
		9,
		33
	],
	"./Type2/index.js": [
		"3IRy",
		9,
		33
	],
	"./Type2/upsells": [
		"+i1F",
		9,
		78
	],
	"./Type2/upsells.jsx": [
		"+i1F",
		9,
		78
	],
	"./Type2/upsells.module.scss": [
		"x5Nb",
		7,
		159
	],
	"./index": [
		"wOor",
		9
	],
	"./index.js": [
		"wOor",
		9
	],
	"./upsellLayoutSelector": [
		"kv9J",
		9
	],
	"./upsellLayoutSelector.js": [
		"kv9J",
		9
	],
	"./withUpsellItem": [
		"jmUG",
		9,
		121
	],
	"./withUpsellItem.jsx": [
		"jmUG",
		9,
		121
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "cipw";
module.exports = webpackAsyncContext;